export const getCommonHeaders = (item, token) => ({
  'x-nd-meta-data': btoa(JSON.stringify({ // base64 value
    group: item?.groupHash || '',
    franchise: item?.franchiseHash || '',
    location: item?.locationHash || '',
    groupSoftware: item?.groupSoftwareHash || '',
  })),
  Authorization: `Bearer ${token}`,
});

export default {};
